import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap';
import { YesNoConfirmation1Component } from '../modal-pop-ups/yes-no-confirmation1/yes-no-confirmation1.component';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-assigned',
  templateUrl: './customer-assigned.component.html'
})
export class CustomerAssignedComponent implements OnInit {
  private notifier: NotifierService;
  filters_form: FormGroup;
  isShow: boolean = false;
  searchText;
  stations;
  arAssingedTrans = [];
  activeTab;
  constructor(
    private spinner: NgxSpinnerService,
    notifierService: NotifierService,
    private arService: ArService,
    private customerService: CustomerService,
    private modalService: BsModalService,
    private router: Router
  ) {
    this.notifier = notifierService;

  }

  ngOnInit() {
    this.getAssignedTransactions();
  }

  ManualClosure(id) {
    //console.log(id)
    const initialState = {
      title: `Do you want to manually close the payment for the Reservation ${id} ?`,
      currentTabIndex: 1
    };
    const modalRef = this.modalService.show(YesNoConfirmation1Component, { initialState });
    modalRef.setClass('modal-lg modal-dialog-centered modal-dialog-scrollable');
    modalRef.content.event.subscribe(res => {
      //console.log(res)
      if (res.data) {
        // console.log(res.data)
        let resIdsList = [];
        resIdsList.push(id);
        let postData = {
          "resIds": resIdsList
        }
        this.spinner.show();
        this.customerService.manualClosurePaymentForCustomer(postData).subscribe(resData => {
          this.getAssignedTransactions();
          this.spinner.hide();
          this.notifier.notify('success', 'Payment has been closed manually.');
          setTimeout(() => {
            this.reload('home/customer-dashboard');
          }, 1000);
        }, (error: any) => {
          this.spinner.hide();
          console.log(error);
        });
      } else {
        modalRef.hide()
      }
    })
  }

  getAssignedTransactions() {
    this.searchText = ''
    this.spinner.show();
    this.customerService.toBeBilledCustomerTransactions().subscribe(res => {
      this.spinner.hide();
      if (res['status'] && res['result'].length > 0) {
        this.arAssingedTrans = res['result'];
        //  console.log(this.arAssingedTrans);
      }
    });
  }

  // onBackToDashboard(){
  //   this.router.navigateByUrl('home/ar-dashboard')
  // }
  // isActive(path:string){
  //  return this.router.isActive(path, false)
  // }

  captureCCardAmount(data) {
    const ccData = {
      RESID: data.RESID,
      TXREFNUM: data.TXREFNUM,
      CURRENCY_FLAG: data.CURRENCY_FLAG
    }
    this.spinner.show();
    this.arService.multiACTransactionForCC(ccData).subscribe(async res => {
      this.spinner.hide();
      if (res['status']) {
        this.notifier.notify('success', 'Payment captured successfully');
        //  console.log(res);
        this.getAssignedTransactions();
      } else {
        this.notifier.notify('warning', 'Payment capture faild');
      }
    });
  }

  async reload(url: string): Promise<boolean> {
    await this.router.navigateByUrl('.', { skipLocationChange: true });
    return this.router.navigateByUrl(url);
  }

  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

}
